import { render, staticRenderFns } from "./FriendlyLinkTop.vue?vue&type=template&id=248be0e2&scoped=true"
import script from "./FriendlyLinkTop.vue?vue&type=script&lang=js"
export * from "./FriendlyLinkTop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248be0e2",
  null
  
)

export default component.exports